import React from "react";
import { Container, Section, Skills } from "./styles";
import HeaderLogo from "../../components/headerLogo/index";
import LogoUnicesumar from "../../assets/logos/unicesumar.png";
import LogoUdemy from "../../assets/logos/udemy.png";
import LogoTrybe from "../../assets/logos/trybe.png";
import LogoSolyd from "../../assets/logos/solyd.png";
import LogoSoftex from "../../assets/logos/softex.png";
import TitlePage from "../../components/titlePage/index";
import AnimatedBackground from "../../components/background/index";
import TechCard from "../../components/techCard/index";
import EducationCard from "../../components/educationCard/index";

import { SiRedux, SiStyledcomponents, SiTestinglibrary } from "react-icons/si";
import { VscEditorLayout } from "react-icons/vsc";
import { RiLayoutMasonryFill } from "react-icons/ri";

import {
  FaHtml5,
  FaCss3Alt,
  FaJsSquare,
  FaBootstrap,
  FaGitSquare,
  FaReact,
  FaUserAlt,
  FaHandshake,
  FaHeart,
  FaTools,
  FaMicrophone,
  FaLightbulb,
  FaBrain,
  FaCogs,
  FaNodeJs,
  FaDocker,
  FaGithubAlt,
} from "react-icons/fa";

function Resumo() {
  return (
    <>
      <AnimatedBackground />
      <Container>
        <HeaderLogo />
        <TitlePage subtitle="Resumo" title="Educação" />
        <Section>
          <h1>Formação Acadêmica</h1>
          <div>
            <EducationCard
              date="2024 - 2025"
              course="Backend com Python e Flask"
              entity="Softex-Penambuco"
              link="https://softexpe.org.br/"
              image={LogoSoftex}
              description="Logo Trybe"
            />
            <EducationCard
              date="2022 - 2023"
              course="Desenvolvimento Web Full Stack"
              entity="Escola de Programação Online"
              link="https://www.betrybe.com/"
              image={LogoTrybe}
              description="Logo Trybe"
            />
            <EducationCard
              date="2017 - 2020"
              course="Análise e Desenvolvimento de Sistemas"
              entity="Universidade Unicesumar"
              link="https://www.unicesumar.edu.br/home/"
              image={LogoUnicesumar}
              description="Logo Unicesumar"
            />
            <EducationCard
              date="2018 - 2020"
              course="Hacking Pentest"
              entity="Cursos Online"
              link="https://solyd.com.br/"
              image={LogoSolyd}
              description="Logo Solyd"
            />
            <EducationCard
              date="2019 - 2021"
              course="Pentest Profissional v2020"
              entity="Cursos Online"
              link="https://www.udemy.com/"
              image={LogoUdemy}
              description="Logo udemy"
            />

          </div>
        </Section>
        <Skills>
          <div>
            <h1>Soft Skills</h1>
            <ul>
              <TechCard icon={<FaUserAlt />} tech="Foco no cliente" />
              <TechCard icon={<FaHandshake />} tech="Trabalho em Equipe" />
              <TechCard icon={<FaMicrophone />} tech="Comunicação" />
              <TechCard icon={<FaLightbulb />} tech="Problem-solving" />
              <TechCard icon={<FaHeart />} tech="Paixão por aprender" />
              <TechCard icon={<FaTools />} tech="Persistência" />
              <TechCard icon={<FaBrain />} tech="Criatividade" />
            </ul>
          </div>
          <div>
            <h1>Hard Skills</h1>
            <ul>
              <TechCard icon={<FaHtml5 />} tech="Html" />
              <TechCard icon={<FaCss3Alt />} tech="Css" />
              <TechCard icon={<FaJsSquare />} tech="Javascript" />
              <TechCard icon={<FaBootstrap />} tech="Bootstrap" />
              <TechCard icon={<FaReact />} tech="React" />
              <TechCard icon={<SiRedux />} tech="Redux" />
              <TechCard icon={<FaGitSquare />} tech="Git" />
              <TechCard icon={<FaGithubAlt />} tech="GitHub" />
              <TechCard icon={<FaNodeJs />} tech="Noções de node" />
              <TechCard
                icon={<SiStyledcomponents />}
                tech="Styled-components"
              />
              <TechCard icon={<FaDocker />} tech="Docker" />
              <TechCard icon={<SiTestinglibrary />} tech="RTL" />
              <TechCard icon={<RiLayoutMasonryFill />} tech="Noções de UX/UI" />
              <TechCard icon={<VscEditorLayout />} tech="Layouts responsivo" />
              <TechCard icon={<FaCogs />} tech="Consumo de API" />
            </ul>
          </div>
        </Skills>
      </Container>
    </>
  );
}

export default Resumo;
